import { render, staticRenderFns } from "./AscCaption.vue?vue&type=template&id=79c3272f&"
import script from "./AscCaption.vue?vue&type=script&lang=js&"
export * from "./AscCaption.vue?vue&type=script&lang=js&"
import style0 from "./AscCaption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports